import PropTypes from "prop-types"
import FullSizeArtifactDialog from "../../full-size-artifact-dialog"
import ExplainSteps from "./explain-steps"
import ArtifactDataGrid from "./artifact-data-grid"
import ExportMenu from "./toolbar-components/export-menu"
import QuickFilter from "./toolbar-components/quick-filter"
import { Divider } from "@mui/material"

export default function FullSizeTable({ open, onClose, columns, rows, explainSteps }) {
  // Custom toolbar components for full-size dialog (no Pin button)
  const toolbarComponents = (
    <>
      <ExportMenu />
      <Divider orientation="vertical" className="component_artifact-data-grid__divider" />
      <QuickFilter />
    </>
  )

  return (
    <FullSizeArtifactDialog
      open={open}
      onClose={onClose}
      title="Generated Table"
    >
      {explainSteps && <ExplainSteps explainSteps={explainSteps} />}
      <ArtifactDataGrid
        columns={columns}
        rows={rows}
        className="table-artifact-full-screen-data-grid"
        toolbarComponents={toolbarComponents}
      />
    </FullSizeArtifactDialog>
  )
}

FullSizeTable.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  explainSteps: PropTypes.string,
}
